import React from "react"
import { useEffect, useRef } from "react"

const Underlay = () => {
    const element = useRef(null)

    useEffect(() => {
        element.current.classList.remove("hidden")
        element.current.classList.add("show")
    }, [])

    return (
        <div className="fullcontainer hidden" ref={element}>
            <div className="h-center">
                <div id="instructions">
                    <p>
                        <b className="red">—</b>
                        <br />
                        Click on the unwanted christmas decoration to get rid of it.
                    </p>
                    <div className="shortline"></div>
                </div>
            </div>

            <div className="center">
                <div className="headlineblock">
                    <h1 className="outlined-background">
                        <em>safe and merry christmas</em>
                    </h1>
                </div>
            </div>
        </div>
    )
}

export default Underlay
